module.exports = __webpack_public_path__ + "cement/img/蒙版组 150@2x.064148e6.png";